// extracted by mini-css-extract-plugin
export var borderRadius = "_5i-4";
export var large = "_5i-3";
export var logoContainer = "_5i-0";
export var nameLogo = "_5i-2";
export var small = "_5i-1";